import axiosInstance from "../axios/axios_instance"
const http = axiosInstance("/protected",  null, "/dashboard")


const getTodoList = () => http.get('/todo_list');
const newTodo = (body) => http.post('/todo_list', body);
const editTodo = (id, body) => http.put(`/todo_list/${id}`, body);
const deleteTodo = (id) => http.delete(`/todo_list/${id}`);
const getCoachROI = () => http.get(`/coach_roi`);
const getTeamCards = () => http.get('/team_cards')
const getValidateEmail = () => http.get('/validate_email');
const putValidateEmail = (body) => http.put('/validate_email', body)


export default {
    getTodoList,
    newTodo,
    editTodo,
    deleteTodo,
    getCoachROI,
    getTeamCards,
    getValidateEmail,
    putValidateEmail,
}